//NEW: UI_REVAMP
import { Box, Flex, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { downloadImage } from '../../utils/downloadImage';
import { getTicketStatus } from '../../utils/getTicketStatus';
import ImgComp from '../../utils/ImgComp';
import { ConvertedTime } from '../../utils/Time';

export const DetailRow = ({
	label,
	value,
	valueIcon,
	isStatus,
	color,
	bgColor,
	onDownloadClick,
	isImage,
}) => (
	<Flex justifyContent='space-between' alignItems='center'>
		<Text
			fontSize='14px'
			fontWeight={500}
			color={{ base: '#8F929F', lg: '#545454' }}
			{...(isStatus && {
				pb: isImage ? '15px' : 1,
			})}
		>
			{label}
		</Text>
		<Box
			display='flex'
			alignItems='center'
			gap={2}
			fontWeight={600}
			fontSize='14px'
			{...(isStatus && {
				px: 4,
				py: isImage ? 0 : 1,
				pb: isImage ? '15px' : 1,
				color: color || '#06742F',
				backgroundColor: bgColor || '#76EF9E4D',
				borderRadius: '100px',
			})}
		>
			{valueIcon && (
				<Box
					onClick={onDownloadClick}
					cursor='pointer'
					userSelect='none'
					display={isImage ? 'none' : 'flex'}
				>
					<ImgComp svgName={valueIcon} w={5} h={5} />
				</Box>
			)}
			<Text>{value}</Text>
		</Box>
	</Flex>
);

export const BetDetailsCard = ({ data, downloadId = 'bet-result-ticket', isImage, ...props }) => {
	const [download, setDownload] = useState(false);
	if (!data) return null;
	const ticketStatus = data.ticketStatus || data.status;
	const { statusText, statusColor } = getTicketStatus(ticketStatus, data.isExpire);

	return (
		<Box mb={5} zIndex={3} borderRadius='8px' bg='white' w='full' p={4} {...props}>
			<Flex flexDirection='column' gap={4}>
				<DetailRow
					label='Ticket ID:'
					value={data.ticketNumber}
					valueIcon='download-ticket'
					onDownloadClick={() => {
						if (!download) {
							setDownload(true);

							requestAnimationFrame(() => {
								downloadImage(downloadId);
								setDownload(false);
							});
						}
					}}
					isImage={isImage}
				/>
				<DetailRow
					label='Bet Date Time:'
					value={ConvertedTime({ time: data.date, format: 'DD/MM/YYYY hh:mm A' })}
				/>
				<DetailRow
					label='Draw Date Time:'
					value={ConvertedTime({ time: data.drawTime, format: 'DD/MM/YYYY hh:mm A' })}
				/>
				<DetailRow
					label='Status:'
					value={statusText}
					isStatus
					color={statusColor}
					isImage={isImage}
				/>
			</Flex>
		</Box>
	);
};

export default BetDetailsCard;
